/* src/app/expense-item/presenter/expense-item-presenter.component.scss */
/*# sourceMappingURL=expense-item-presenter.component.css.map */
